import React from 'react'
import { Grid, GridCellProps, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import { Icon } from "@iconify/react"; 
import PopOver from "../popover";

function SubmittedCandidates(props: any) {

    const multiData = (props: any, cell: any) => {
        
        let positionArray : any = []
        //eslint-disable-next-line array-callback-return
        props && props.dataItem.positionStatus && props.dataItem.positionStatus.map((item: any) => {
            if (item.current_stage === 'Submitted to Hirer') {
                return ( positionArray.push(item) )
            }
        })
        if (positionArray && positionArray.length > 1){ 
            return (
                <td>
                    <div className="positionStstus">
                        <PopOver title="Multiple Position" position="rightBottom">
                        { positionArray &&  positionArray.map((item: any, key: number) => {
                            return (
                                <div key={key} className="positionList">
                                    <span className="status warning" />
                                   {cell === "companyCell" ? item.company : cell=== "positionCell" ? item.company + '-' + item.position_name : new Date(item.created_on).toDateString().slice(3) }
                                </div>
                            )
                        })}       
                        </PopOver>
                    </div>
                </td>
            )
        }else{
            return (
                <td>
                    <div>
                        { positionArray &&  positionArray.map((item: any) => {
                            return (
                                <div>
                                    {cell === "companyCell" ? item.company : cell=== "positionCell" ? item.company + '-' + item.position_name : new Date(item.created_on).toDateString().slice(3) }
                                </div>
                            )   
                        })}
                    </div>
                </td>
            )
        }
    }
    
    const companyCell  = (props: GridCellProps) => {
        
        return ( multiData(props, "companyCell")) 
    }

    const positionCell = (props: GridCellProps) => {
        
        return ( multiData(props, "positionCell"))

    }
    const dateCell = (props: GridCellProps) => {
        
        return ( multiData(props, "dateCell"))

    }
  
    return (
        <Grid
            data={props.data}   
            style={{ height: '400px' }}        
        >
        <GridNoRecords>
            <div className="noData">
                <Icon icon="mdi:smiley-neutral-outline" />
                    No data to display
            </div>
        </GridNoRecords>
        <Column field="name" title="Full Name" />
        <Column field="company" title="Company" cell={companyCell}/>
        <Column field="position" title="Position" cell={positionCell} />
        <Column field="dateofsubmission" title="Date of Submission" cell={dateCell} />
        <Column field="ellowStatus" title="Ellow Status" />
        </Grid>
    )

}
export default SubmittedCandidates